import {ArchimateRelationship} from "../../../../common/archimate/ArchimateRelationship";

export class RelationshipTypeFormatter {
    static formatRelationshipType(relationshipType: string | undefined | null) {
        if (!relationshipType) {
            return "";
        }
        return ArchimateRelationship.findByStandardName(relationshipType)?.visibleName || relationshipType;
    }
}